<div class="container-fluid p-0 h-100">
    <div class="row team-card-section">
        <div class="col-md-6 col-lg-3 mb-3 team-card-column" *ngFor="let item of  leavesCards; let i = index; trackBy: trackByName">
            <div  class="card shadow-sm card-stretch rounded-0 p-0" style="height:87px">
                <div  class="card-body py-5 p-5">
                    <div class="d-flex align-items-top no-guttrs justify-content-between">
                        
                        <div class="d-flex">
                            <div *ngIf="isLoaded && !isEmpty">
    <div class="align-items-center text-center usercardground  rounded">
        <img [src]="item.icon" class=" w-40px">
    </div>
</div>
                            <div *ngIf="!isLoaded && isEmpty">
                                <div class="row pl-3">
                                    <div class="col-4">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="card rounded-0">
                                                    <ngx-shimmer-loading [width]="'40px'" [height]="'40px'"></ngx-shimmer-loading>

                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-8">
                                        <div class="row mt-1 no-gutters">
                                            <div class="col-12">
                                                <div class="card border border-0 rounded-0">
                                                    <ngx-shimmer-loading [width]="'90px'" [height]="'15px'"></ngx-shimmer-loading>

                                                </div>

                                            </div>

                                            <div class="col-12">
                                                <div class="card rounded-0">
                                                    <ngx-shimmer-loading [width]="'90px'" [height]="'15px'"></ngx-shimmer-loading>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div *ngIf="isLoaded && !isEmpty">
                                <div class="font-weight-bold ml-2">
                                    {{item.name | localize}}
                                </div>
                                <div class=" ml-2">
                                    <span class="{{item.class}}">

                                        <span *ngIf="i ==0">{{userTimeData.totalMember}}</span>
                                        <span *ngIf="i ==1">{{userTimeData.totalProject}}</span>
                                        <span *ngIf="i ==2">{{userTimeData.pendingProject}}</span>
                                        <span *ngIf="i ==3">{{userTimeData.completedProject}}</span>
                                        <span *ngIf="i ==4">{{userTimeData.leaveRequest}}</span>
                                        <span *ngIf="i ==5">{{absentEmployee}}</span>
                                        <span *ngIf="i ==6">{{userTimeData.lateEmployee}}</span>
                                        <span *ngIf="i ==7">{{userTimeData.arrivedEmployee}}</span>
                                    </span>
                                </div>
                            </div>

                        </div>
                        <div *ngIf="isLoaded && !isEmpty" class="position-relative">
                            <div *ngIf="i==5" >
                                <span>
                                    <div class="progress-wrapper">
                                        <div class="current" [ngStyle]="getOverlayStyle()">{{ absentEmployees }}%</div>
                                        <round-progress [current]="absentEmployees" [max]="max" [color]="gradient ? 'url(#gradient)' : color"
                                                        [background]="background" [radius]="radius" [stroke]="stroke" [clockwise]="clockwise"
                                                        [responsive]="responsive"></round-progress>
                                    </div>
                                </span>
                            </div>
                            <div *ngIf="i==6" class="float-right">
                                <span>
                                    <div class="progress-wrapper">
                                        <div class="current" [ngStyle]="getOverlayStyle()">{{ lateEmployees }}%</div>
                                        <round-progress [current]="lateEmployees" [max]="max" [color]="gradient ? 'url(#gradient)' : color"
                                                        [background]="background" [radius]="radius" [stroke]="stroke" [clockwise]="clockwise"
                                                        [responsive]="responsive"></round-progress>
                                    </div>
                                </span>
                            </div>
                            <div *ngIf="i==7" class="float-right">
                                <span>
                                    <div class="progress-wrapper">
                                        <div class="current" [ngStyle]="getOverlayStyle()">{{ arrivedEmployees }}%</div>
                                        <round-progress [current]="arrivedEmployees ? arrivedEmployees : 0" [max]="max" [color]="gradient ? 'url(#gradient)' : color"
                                                        [background]="background" [radius]="radius" [stroke]="stroke" [clockwise]="clockwise"
                                                        [responsive]="responsive"></round-progress>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
